module.exports = __webpack_public_path__ + "img/project2.b432c8f5.webp";